import React from 'react'
import Card from '../../../common/Card'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Pareto from 'highcharts/modules/pareto';
import SolidGauge from 'highcharts/modules/solid-gauge';
import Highcharts from "@material-ui/core/es/styles/withStyles";
import {convertSecondsToMinutesSecondsFormat} from "../../../common/Util";
import {COLOR_chart_series_first_line} from "../../../common/CustomTheme/ThemeDefault/colors";
import CustomTheme from "../../../common/CustomTheme";

HighchartsMore(ReactHighcharts.Highcharts);
Pareto(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);


var config = {
    chart: {
        type: 'column'
    },
    title: {
        text: 'Tempo médio por estado - Dia'
    },
    xAxis: {
        categories: []
    },
    yAxis: {
        min: 0,
        title: {
            text: 'Total em segundos'
        },
        labels: {

        },
        stackLabels: {
            enabled: true,
            style: {
                fontWeight: 'bold',
                color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
            },

        }
    },
    legend: {
        align: 'center',
        x: -30,
        verticalAlign: 'bottom',
        y: 25,
        floating: true,
        backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
        borderColor: '#CCC',
        borderWidth: 1,
        shadow: false
    },
    tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
    },
    plotOptions: {
        column: {
            stacking: 'normal',
            dataLabels: {
                enabled: true,
                color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
            }
        }
    },
    series: []
};

export default function HourTotalByTypePerDayChart(prop) {
    const { series } = prop;
    if (series) {
        let categories = [];
        let dataMaq = [];
        let dataOper = [];

        series.map(i => {
            categories.push(i.Dia.substring(0,10));
            dataMaq.push( Math.round( (i.TotalTempoCiclo - i.TotalTempoWait) / i.Ciclos) );
            dataOper.push( Math.round(i.TotalTempoWait / i.Ciclos) );
        })

        config = {
            ...config,
            xAxis: {
                categories: categories
            },

            series: [
                {
                    name: 'Maquina em ciclo',
                    data: dataMaq,
                    color: CustomTheme.colors.COLOR_chart_barra_horas_serie_0
                }, {
                    name: 'Espera do Operador',
                    data: dataOper,
                    color: CustomTheme.colors.COLOR_chart_barra_horas_serie_1
                }

            ],
        }

    }


    return (
        <Card>
            <ReactHighcharts config = {config}>
            </ReactHighcharts>
        </Card>
    )
}
